<template>
  <div class="space-info">
    <div class="space-main">
      <div class="title wow bounceInDown">创业空间</div>
      <div class="space-list wow bounceIn">
        <div class="tab-bar">
          <div
            class="tab"
            :class="{ active: tabId === item.dictCode }"
            v-for="item in tabList"
            @click="changeTab(item.dictCode, item.dictLabel)"
            :key="item.dictCode"
          >
            {{ item.dictLabel }}
          </div>
        </div>
        <div class="info-item">
          <div class="info" v-for="item in infoList" :key="item.id">
            <div class="detail">
              <div class="info-title" :title="item.title">
                <router-link class="link" style="color:#fff" :to="{path:'/newsDetail', query:{id: item.id}}" :target="isMobile?'_self':'_blank'">{{ item.title }}</router-link>
              </div>
            </div>
            <div class="desc" style="color:#fff" :title="item.des">
              {{ item.des | wordLimit(85) }}
            </div>
            <div class="date-box">
              <div class="date">
                <div style="color:#fff" class="day">{{item.time | dateFormat('MM-dd')}}</div>
                <div style="color:#fff" class="year">{{item.time | dateFormat('yyyy')}}</div>
              </div>
              <div class="line"></div>
            </div>
          </div>
        </div>
        <router-link :to="{path: '/newsList', query: {typeCode: tabId, name}}" :target="isMobile?'_self':'_blank'" class="more">MORE</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['space'],
  computed: {
    isMobile () {
      return /Android|Windows Phone|iPhone|iPod/i.test(navigator.userAgent)
    }
  },
  data () {
    return {
      tabId: 1,
      name: '',
      tabList: [],
      infoList: []
    }
  },
  watch: {
    space (n, o) {
      this.tabList = n
      this.tabId = n[0]?.dictCode
      this.name = n[0]?.dictLabel
      this.getInfo([this.tabId])
    }
  },
  methods: {
    changeTab (dictCode, dictLabel) {
      this.tabId = dictCode
      this.name = dictLabel
      this.getInfo([this.tabId])
    },
    getInfo (typeCode) {
      this.$axios.post(process.env.VUE_APP_jiaxingUrl + '/system/open/getTextListByPage', { pageNum: 1, pageSize: 3, typeCode }).then(res => {
        const data = res.data
        this.infoList = data.rows.slice(0, 3)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.space-info {
  height: 870px;
  padding-top: 84px;
  background: url(../assets/space-bg.jpg) no-repeat center top;
  background-size: 100% 100%;
  .space-main {
    width: 1200px;
    margin: 0 auto;
    height: 640px;
    .title {
      position: relative;
      height: 40px;
      line-height: 40px;
      font-size: 40px;
      font-weight: 600;
      color: #fff;
      font-family: MicrosoftYaHei-Bold;
      text-align: center;
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -24px;
        width: 80px;
        height: 4px;
        background-color: #fff;
        transform: translateX(-50%);
      }
    }
    .space-list {
      position: relative;
      width: 1200px;
      padding: 30px 60px 90px;
      // background: #fff;
     background:rgba(50,66, 117, 0.9);
      box-shadow: 0px 7px 23px 1px rgba(0, 0, 0, 0.08);
      border-radius: 40px 40px 40px 40px;
      margin-top: 50px;
      color:#fff !important;
      .tab-bar {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #C2C2C2;
        line-height: 42px;
        font-weight: 600;
        font-size: 22px;
        // color: #C2C2C2;
        .tab {
          position: relative;
          cursor: pointer;
          & + .tab {
            margin-left: 133px;
          }
          &.active {
            color: #4370CA;
            &::after {
              content: "";
              width: 24px;
              height: 3px;
              position: absolute;
              left: 50%;
              top: 42px;
              transform: translateX(-50%);
              background-color: #4370CA;
            }
          }
        }
      }
      .info-item {
        padding-top: 36px;
        .info {
          & + .info {
            margin-top: 22px;
          }
          .detail {
            display: flex;
            align-items: center;
            height: 36px;
            font-weight: 600;
            color: #fff;
            font-size: 16px;
          }
          .link {
            color: #334275;
            text-decoration: none;
          }
          .info-title {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .desc {
            min-height: 44px;
            line-height: 22px;
            color: #828282;
            font-size: 14px;
          }
          .date-box {
            display: flex;
            align-items: center;
            margin-top: 18px;
            height: 22px;
            .date {
              display: flex;
              margin-right: 18px;
              line-height: 22px;
              color: #989898;
            }
            .day {
              font-size: 22px;
            }
            .year {
              margin-left: 6px;
              font-size: 12px;
            }
            .line {
              flex: 1;
              height: 1px;
              background-color: #C2C2C2;
            }
          }
        }
      }
      .more {
        position: absolute;
        bottom: 30px;
        right: 60pX;
        width: 102px;
        height: 38px;
        line-height: 38px;
        border: 1px solid #fff;
        color: #334275;
        text-decoration: none;
        border-radius: 4px;
        text-indent: 21px;
        font-size: 14px;
        color: #fff;
        &::after {
          position: absolute;
          content: "";
          top: 14px;
          right: 20px;
          width: 5px;
          height: 5px;
          // border: 1px solid #334275;
          border: 1px solid #fff;
          border-bottom-color: transparent;
          border-left-color: transparent;
          transform: rotate(45deg);
        }
      }
    }
  }
}
</style>
